var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "report_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#report_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.712c.229 0 .42-.078.576-.233a.781.781 0 00.232-.575.781.781 0 00-.232-.576.781.781 0 00-.576-.232.781.781 0 00-.575.232.781.781 0 00-.233.576c0 .229.078.42.232.575a.781.781 0 00.576.233zm0-3.481c.213 0 .391-.072.535-.216a.726.726 0 00.215-.534v-4.539a.726.726 0 00-.216-.534.727.727 0 00-.534-.216.725.725 0 00-.535.216.726.726 0 00-.215.534v4.539c0 .212.072.39.216.534a.726.726 0 00.534.216zM13.21 24.5a1.802 1.802 0 01-1.275-.527l-3.908-3.908A1.801 1.801 0 017.5 18.79v-5.58a1.801 1.801 0 01.527-1.275l3.908-3.908A1.801 1.801 0 0113.21 7.5h5.58a1.801 1.801 0 011.275.527l3.908 3.908a1.802 1.802 0 01.527 1.275v5.58a1.802 1.802 0 01-.527 1.275l-3.908 3.908a1.802 1.802 0 01-1.275.527h-5.58zM13.1 23h5.8l4.1-4.1v-5.8L18.9 9h-5.8L9 13.1v5.8l4.1 4.1z",
    fill: "#fff"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/report.faf88914.svg";
export { SvgReport as ReactComponent };